import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';
import { SearchComponent } from '../../search/search.component';

@Component({
  selector: 'app-order-organisation-select',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent,
    SearchComponent
  ],
  templateUrl: './order-organisation-select.component.html',
  styleUrl: './order-organisation-select.component.scss'
})
export class OrderOrganisationSelectComponent implements OnInit {
  @Input() reload: boolean = false;

  modalTitle: string = 'Organisatie koppelen';
  modalStyle: boolean = false;

  loading: boolean = false;

  searchTerm: string = "";

  @Input() item: any = {};
  organisationList: any[] = [];

  constructor(
    private apiService: ApiService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.getOrganisations();
  }

  setItem(item: any) {
    this.item = item;
    this.getOrganisations();
  }

  getOrganisations() {
    this.loading = true;
    this.apiService.get('/office/organisations?limit=100&sort=name&direction=asc&keyword=' + this.searchTerm)
      .then((response: any) => {
        this.organisationList = response.data.map((organisation: any) => ({
          ...organisation,
        }));
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
      });
  }

  select(item: any) {
    let self = this;
    this.loading = true;
    self.activeModal.close(item);
  }

  search(keyword: any) {
    this.searchTerm = keyword;
    this.getOrganisations();
  }
}
